function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { View, StyleSheet, Text, Pressable } from 'react-native';
import FlashMessage, { showMessage as FlashShowMessage, hideMessage as FlashHideMessage } from 'react-native-flash-message';
import CircularProgress from '../Progress/CircularProgress';
import Swipeable from './Swipeable';
import { ValidationApprove } from '@suranceadmin/icons/native';
import { getStatusBarHeight } from '../../constants';
import { useTheme } from '../../core/theming';

const LocalNotificationBox = props => {
  return /*#__PURE__*/React.createElement(FlashMessage, _extends({
    MessageComponent: MessageComponent
  }, props));
};

const MessageComponent = props => {
  const {
    message: {
      duration,
      message
    },
    accessible,
    accessibilityLabel,
    testID
  } = props;
  const theme = useTheme();

  const hideMessage = () => {
    FlashHideMessage();
  };

  return /*#__PURE__*/React.createElement(Swipeable, {
    onSwipeAway: hideMessage
  }, /*#__PURE__*/React.createElement(Pressable, {
    accessible: accessible,
    accessibilityLabel: accessibilityLabel,
    testID: testID,
    style: [styles.container, {
      backgroundColor: theme.colors.icon.valid,
      marginTop: getStatusBarHeight()
    }],
    onPress: hideMessage
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.textView
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.title, theme.fonts.caption1Bold]
  }, message)), /*#__PURE__*/React.createElement(View, {
    style: styles.iconContainer
  }, /*#__PURE__*/React.createElement(CircularProgress, {
    progress: 0,
    startProgress: 100,
    radius: 16,
    strokeWidth: 1,
    duration: duration,
    tintColor: "white",
    color: "transparent"
  }), /*#__PURE__*/React.createElement(ValidationApprove, {
    style: styles.icon,
    color: "white",
    width: 26,
    height: 26
  }))));
};

export const showMessage = _ref => {
  let {
    duration,
    message,
    ...props
  } = _ref;
  const calcDuration = duration || calculateDuration(message);
  FlashShowMessage({
    duration: calcDuration,
    message,
    ...props
  });
};
export const hideMessage = () => {
  FlashHideMessage();
};

const calculateDuration = text => {
  const duration = text.length / 30;

  if (duration < 3) {
    return 3000;
  } else if (duration > 10) {
    return 10000;
  } else {
    return duration * 1000;
  }
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    minHeight: 68,
    marginHorizontal: 8,
    borderRadius: 2
  },
  textView: {
    flex: 1,
    marginVertical: 24,
    marginStart: 32,
    marginEnd: 8
  },
  title: {
    color: 'white'
  },
  iconContainer: {
    width: 32,
    height: 32,
    marginTop: 18,
    marginEnd: 16,
    justifyContent: 'center',
    alignItems: 'center'
  },
  icon: {
    position: 'absolute'
  }
});
export default LocalNotificationBox;
//# sourceMappingURL=index.js.map